module.exports = __webpack_public_path__ + "img/main_banner_02.579d08f.jpg";